import ProfileStep from './ProfileStep';
import { AwsaiPart1, AwsaiPart2, ExtendedModule } from './QuestionRenderer';
import WorkflowsStep from './WorkflowsStep';

const STEP_HEADINGS = {
  2: { title: 'AWSAI Core — Decision & Process', subtitle: 'Part 1 of 2 · Decision Dependency and Process Consistency' },
  3: { title: 'AWSAI Core — Work & Errors', subtitle: 'Part 2 of 2 · Repetitive Work and Error Control' },
  4: { title: 'Extended Diagnostic Module', subtitle: 'Data, Systems, People, and Governance — your AI-readiness foundation' },
};

const LIKERT_INSTRUCTIONS =
  'Rate each statement on a 5-point scale: 1 = Strongly Disagree → 5 = Strongly Agree.';

const StepHeader = ({ title, subtitle, testId }) => (
  <div className="mb-6" data-testid={testId}>
    <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
      {title}
    </h2>
    <p className="text-slate-500 mt-1 text-sm sm:text-base">{subtitle}</p>
    <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-teal-50 border border-teal-100 text-teal-800">
      <span className="w-1.5 h-1.5 rounded-full bg-teal-500"></span>
      <span className="text-[11px] font-semibold tracking-wide uppercase">{LIKERT_INSTRUCTIONS}</span>
    </div>
  </div>
);

const AssessmentStepBody = ({ step, form }) => {
  if (step === 1) {
    return <ProfileStep profile={form.profile} onChange={form.setProfile} />;
  }
  if (step === 2) {
    const h = STEP_HEADINGS[2];
    return (
      <div data-testid="awsai-core-step-1">
        <StepHeader title={h.title} subtitle={h.subtitle} />
        <AwsaiPart1 values={form.awasi} onUpdate={form.updateAwasi} />
      </div>
    );
  }
  if (step === 3) {
    const h = STEP_HEADINGS[3];
    return (
      <div data-testid="awsai-core-step-2">
        <StepHeader title={h.title} subtitle={h.subtitle} />
        <AwsaiPart2 values={form.awasi} onUpdate={form.updateAwasi} />
      </div>
    );
  }
  if (step === 4) {
    const h = STEP_HEADINGS[4];
    return (
      <div data-testid="extended-module-step">
        <StepHeader title={h.title} subtitle={h.subtitle} />
        <ExtendedModule values={form.extended} onUpdate={form.updateExtended} />
      </div>
    );
  }
  return (
    <WorkflowsStep
      workflows={form.workflows}
      consent={form.consent}
      onUpdateWorkflow={form.updateWorkflow}
      onConsentChange={form.setConsent}
    />
  );
};

export default AssessmentStepBody;
